import { formatCurrency } from 'services/number'

export const PER_PAGE = 10
export const PRICES = [
  { value: '', label: 'Todo' },
  { value: '5000', label: '5,000' },
  { value: '10000', label: '10,000' },
  { value: '15000', label: '15,000' },
  { value: '20000', label: '20,000' },
  { value: '25000', label: '25,000' },
  { value: '30000', label: '30,000' },
  { value: '35000', label: '35,000' },
  { value: '40000', label: '40,000' },
  { value: '45000', label: '45,000' },
  { value: '50000', label: '50,000' },
  { value: '100000', label: '100,000' },
  { value: '200000', label: '200,000' },
  { value: '300000', label: '300,000' },
  { value: '400000', label: '400,000' },
  { value: '500000', label: '500,000' },
  { value: '600000', label: '600,000' },
  { value: '700000', label: '700,000' },
  { value: '800000', label: '800,000' },
  { value: '900000', label: '900,000' },
  { value: '1000000', label: '1M' },
  { value: '1100000', label: '1.1M' },
  { value: '1200000', label: '1.2M' },
  { value: '1300000', label: '1.3M' },
  { value: '1400000', label: '1.4M' },
  { value: '1500000', label: '1.5M' },
  { value: '1600000', label: '1.6M' },
  { value: '1700000', label: '1.7M' },
  { value: '1800000', label: '1.8M' },
  { value: '1900000', label: '1.9M' },
  { value: '2000000', label: '2.0M' },
  { value: '1250000', label: '2.25M' },
  { value: '1500000', label: '2.5M' },
  { value: '1750000', label: '2.75M' },
  { value: '3000000', label: '3M' },
  { value: '35000000', label: '3.5M' },
  { value: '4000000', label: '4M' },
  { value: '5000000', label: '5M' },
  { value: '10000000', label: '10M' }
]

export const STATUS = [
  { value: 'APPROVED', label: 'Aprobada' },
  { value: 'PENDING_FOR_APPROVAL', label: 'En revisión' },
  { value: 'USER_REVIEW_NEEDED', label: 'Rechazada' },
  { value: 'DRAFT', label: 'Borrador' },
  { value: 'CLAIMED', label: 'PDC' }
]

export const OPERATIONS = [
  { value: 'SELL', label: 'Venta' },
  { value: 'RENT', label: 'Renta' }
]

export const PROPERTY_TYPES = [
  {
    label: 'Departamento',
    value: 'APARTMENT'
  },
  {
    label: 'Casa',
    value: 'HOUSE'
  },
  {
    label: 'Terreno',
    value: 'LOTS'
  },
  {
    label: 'Cuarto',
    value: 'ROOMS'
  },
  {
    label: 'Local',
    value: 'STORE'
  },
  {
    label: 'Bodega',
    value: 'WAREHOUSE'
  },
  {
    label: 'Oficina',
    value: 'OFFICE'
  }
]

export const TRIGGER_CLOSE_PROPERTY_OPTIONS = [
  'REMOVE_SOLD_ME',
  'REMOVE_SOLD_NEXIMER',
  'REMOVE_SOLD_OTHER'
]

export const labelsPriceAndDate = (obj, key) => {
  if(key === 'price__amount__lte'){
    return `Máximo ${formatCurrency(obj[key])}`
  }
  if(key === 'price__amount__gte'){
    return `Mínimo ${formatCurrency(obj[key])}`
  }
  if(key === 'created_at__gte'){
    return `Desde ${obj[key]}`
  }
  if(key === 'created_at__lte'){
    return `Hasta ${obj[key]}`
  }
}